import { FilterOperator } from '@nemuru-eng/js-api-client';
import { useParams } from 'react-router-dom';

import { withPermissionsModule } from '@/utils/withPermissionsModule';

import { ApplicationList } from '../../../shared/components/ApplicationList/ApplicationList';

const MerchantApplicationsList = () => {
  const { merchantId } = useParams();

  if (!merchantId) return null;

  const merchantFilter = [
    {
      field: 'merchant_id',
      operator: FilterOperator.EQUAL,
      value: merchantId,
    },
  ];

  return <ApplicationList merchantId={merchantId} filters={merchantFilter} />;
};

export const MerchantApplicationsListModule = withPermissionsModule(MerchantApplicationsList);
